const state = {
  // 当前考试所参与的班级（不包含全部班级选项）
  currentExamClazzList: [],
  // 班级列表
  clazzList: [],
  // 模拟考试-试卷列表
  paperList: [
    { id: '1', paperName: '试卷1' },
    { id: '2', paperName: '试卷2' }
  ],
  // 即评练习-试卷（practiceListJson）
  practicePaper: {},
  curMedia: {
    url: '', // 当前播放的媒体资源
    from: '' // 当前媒体资源的来源, answerScore: 答案得分，control: 播放控件
  }
}

const getters = {
  currentExamClazzList: state => state.currentExamClazzList,
  clazzList: state => state.clazzList,
  paperList: state => state.paperList,
  practicePaper: state => state.practicePaper,
  curMedia: state => state.curMedia
}

const mutations = {
  SET_CURRENT_EXAM_CLAZZ_LIST(state, payload) {
    state.currentExamClazzList = payload
  },
  SET_CLAZZ_LIST(state, payload) {
    state.clazzList = payload
  },
  SET_PAPER_LIST(state, payload) {
    state.paperList = payload
  },
  SET_PRACTICE_PAPER(state, payload) {
    state.practicePaper = payload
  },
  SET_CUR_MEDIA(state, payload) {
    state.curMedia = payload
  }
}

const actions = {
  setCurrentExamClazzList({ commit }, payload) {
    commit('SET_CURRENT_EXAM_CLAZZ_LIST', payload)
  },
  setClazzList({ commit }, payload) {
    commit('SET_CLAZZ_LIST', payload)
  },
  setPaperList({ commit }, payload) {
    commit('SET_PAPER_LIST', payload)
  },
  setPracticePaper({ commit }, payload) {
    commit('SET_PRACTICE_PAPER', payload)
  },
  setCurMedia({ commit }, payload) {
    commit('SET_CUR_MEDIA', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
